import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

@Component({
    selector: 'fi-download-app-dialog',
    template: `
        <p class="fi-dialog-content-message" [innerHTML]="'download_app.dialog_content' | fiAppText"></p>
        <div class="dialog-footer">
            <button mat-stroked-button class="dialog-button fi-button--secondary" (click)="close()">
                {{ 'common.cancel' | fiAppText }}
            </button>
            <a class="dialog-button fi-button--primary BrandedBackgroundColor" [href]="url">
                {{ 'common.download_app' | fiAppText }}
            </a>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-download-app-dialog' },
    standalone: false,
})
export class FiDownloadAppDialogComponent extends FiDialogsContentBase<string, void> {
    get url(): string {
        return this.data;
    }

    close() {
        this.dialogRef.close();
    }
}
